import React from "react";
import "./mobilewarning.scss";

export const MobileWarning = () => {
  return (
    <div className="mobile-warning-container">
      <p>Retirement application best viewed in desktop and tablet</p>
    </div>
  );
};
